import { get } from 'lodash';
import { connect } from 'react-redux';
import { handleShareInsuranceCheckboxChange } from '../../actions/InsuranceCardActions';
import { openImagePreview } from '../../actions/InsuranceCardLightBoxActions';
import { INSURANCE_ID_REQUIRED } from '../../components/AppointmentRequirements/constants';
import { hasRequirement } from '../../components/AppointmentRequirements/helpers';
import { BookingStateProperties } from '../../constants';
import bookingStateSelector from '../../selectors/BookingStateSelector';
import patientSelector from '../../selectors/PatientSelector';
import InsuranceCardSectionView from './InsuranceCardSectionView';

const iceCardIsRequiredButMissing = (iceRequestToken, insuranceIdRequired) =>
    iceRequestToken && insuranceIdRequired;

const insuranceAvailableButNotShared = (
    availableInsuranceCardDataId,
    isInsuranceCardShared
) => availableInsuranceCardDataId && !isInsuranceCardShared;

export const mapStateToProps = (state) => {
    const patient = patientSelector(state);
    const { availableInsuranceCardDataId } = patient;
    const { insuranceCardImageUrls } = patient.selectedInsuranceCard || {};

    const bookingState = bookingStateSelector(state);
    const isInsuranceCardShared = get(
        bookingState,
        BookingStateProperties.isInsuranceCardShared,
        false
    );
    const iceRequestToken = get(
        bookingState,
        BookingStateProperties.iceRequestToken,
        null
    );
    const requirements = get(
        bookingState,
        BookingStateProperties.requirements,
        []
    );
    const insuranceIdRequired = hasRequirement(
        INSURANCE_ID_REQUIRED,
        requirements
    );

    let imgSrc = null;
    if (insuranceCardImageUrls && insuranceCardImageUrls.front) {
        imgSrc = insuranceCardImageUrls.front;
    }

    const availableButNotShared = insuranceAvailableButNotShared(
        availableInsuranceCardDataId,
        isInsuranceCardShared
    );
    const showErrorMessage = !!(
        availableButNotShared &&
        iceCardIsRequiredButMissing(iceRequestToken, insuranceIdRequired)
    );

    return {
        hasIceRequestToken: !!iceRequestToken,
        imgSrc,
        isInsuranceCardShared,
        showErrorMessage,
    };
};

export const mapDispatchToProps = {
    openImagePreview,
    handleShareInsuranceCheckboxChange,
};

export const InsuranceCardSection = connect(
    mapStateToProps,
    mapDispatchToProps
)(InsuranceCardSectionView);
